var map = {
	"./2x-square.jpg": "./src/assets/images/2x-square.jpg",
	"./aave-square.png": "./src/assets/images/aave-square.png",
	"./arrow-down-blue.svg": "./src/assets/images/arrow-down-blue.svg",
	"./arrow-down-grey.svg": "./src/assets/images/arrow-down-grey.svg",
	"./arrow-right-white.png": "./src/assets/images/arrow-right-white.png",
	"./arrow-right.svg": "./src/assets/images/arrow-right.svg",
	"./arrow-up-right-blue.svg": "./src/assets/images/arrow-up-right-blue.svg",
	"./avalanche-logo.png": "./src/assets/images/avalanche-logo.png",
	"./bao-square.png": "./src/assets/images/bao-square.png",
	"./bento-color.png": "./src/assets/images/bento-color.png",
	"./bento-square.png": "./src/assets/images/bento-square.png",
	"./big_unicorn.png": "./src/assets/images/big_unicorn.png",
	"./binance-coin-logo.png": "./src/assets/images/binance-coin-logo.png",
	"./blue-loader.svg": "./src/assets/images/blue-loader.svg",
	"./burger.svg": "./src/assets/images/burger.svg",
	"./ch-flag.png": "./src/assets/images/ch-flag.png",
	"./chain-animated.gif": "./src/assets/images/chain-animated.gif",
	"./chef.svg": "./src/assets/images/chef.svg",
	"./circle-grey.svg": "./src/assets/images/circle-grey.svg",
	"./circle.svg": "./src/assets/images/circle.svg",
	"./coinbaseWalletIcon.svg": "./src/assets/images/coinbaseWalletIcon.svg",
	"./coming-soon.png": "./src/assets/images/coming-soon.png",
	"./de-flag.png": "./src/assets/images/de-flag.png",
	"./dropdown-blue.svg": "./src/assets/images/dropdown-blue.svg",
	"./dropdown.svg": "./src/assets/images/dropdown.svg",
	"./dropup-blue.svg": "./src/assets/images/dropup-blue.svg",
	"./en-flag.png": "./src/assets/images/en-flag.png",
	"./error-triangle.svg": "./src/assets/images/error-triangle.svg",
	"./es-flag.png": "./src/assets/images/es-flag.png",
	"./ethereum-logo.png": "./src/assets/images/ethereum-logo.png",
	"./fantom-logo.png": "./src/assets/images/fantom-logo.png",
	"./fortmaticIcon.png": "./src/assets/images/fortmaticIcon.png",
	"./gridPlusWallet.png": "./src/assets/images/gridPlusWallet.png",
	"./harmony-logo.png": "./src/assets/images/harmony-logo.png",
	"./he-flag.png": "./src/assets/images/he-flag.png",
	"./heco-logo.png": "./src/assets/images/heco-logo.png",
	"./it-flag.png": "./src/assets/images/it-flag.png",
	"./ja-flag.png": "./src/assets/images/ja-flag.png",
	"./kashi-color-flat.png": "./src/assets/images/kashi-color-flat.png",
	"./kashi-kanji-wires.png": "./src/assets/images/kashi-kanji-wires.png",
	"./link.svg": "./src/assets/images/link.svg",
	"./logo.png": "./src/assets/images/logo.png",
	"./magnifying-glass.svg": "./src/assets/images/magnifying-glass.svg",
	"./matic-logo.png": "./src/assets/images/matic-logo.png",
	"./menu.svg": "./src/assets/images/menu.svg",
	"./metamask.png": "./src/assets/images/metamask.png",
	"./miso-banner.jpg": "./src/assets/images/miso-banner.jpg",
	"./miso-logo.png": "./src/assets/images/miso-logo.png",
	"./moonbeam-logo.png": "./src/assets/images/moonbeam-logo.png",
	"./more-info.svg": "./src/assets/images/more-info.svg",
	"./noise.png": "./src/assets/images/noise.png",
	"./noise_original.png": "./src/assets/images/noise_original.png",
	"./okex-logo.png": "./src/assets/images/okex-logo.png",
	"./placeholder.png": "./src/assets/images/placeholder.png",
	"./plus-blue.svg": "./src/assets/images/plus-blue.svg",
	"./plus-grey.svg": "./src/assets/images/plus-grey.svg",
	"./portisIcon.png": "./src/assets/images/portisIcon.png",
	"./question-mark.svg": "./src/assets/images/question-mark.svg",
	"./question.svg": "./src/assets/images/question.svg",
	"./ro-flag.png": "./src/assets/images/ro-flag.png",
	"./ru-flag.png": "./src/assets/images/ru-flag.png",
	"./sort-icon.svg": "./src/assets/images/sort-icon.svg",
	"./spinner.svg": "./src/assets/images/spinner.svg",
	"./sushi.png": "./src/assets/images/sushi.png",
	"./token-list/lists-dark.png": "./src/assets/images/token-list/lists-dark.png",
	"./token-list/lists-light.png": "./src/assets/images/token-list/lists-light.png",
	"./token-logo.png": "./src/assets/images/token-logo.png",
	"./torusIcon.png": "./src/assets/images/torusIcon.png",
	"./transaction-rejected.png": "./src/assets/images/transaction-rejected.png",
	"./trustWallet.png": "./src/assets/images/trustWallet.png",
	"./vi-flag.png": "./src/assets/images/vi-flag.png",
	"./vote.png": "./src/assets/images/vote.png",
	"./walletConnectIcon.svg": "./src/assets/images/walletConnectIcon.svg",
	"./x.svg": "./src/assets/images/x.svg",
	"./xdai-logo.png": "./src/assets/images/xdai-logo.png",
	"./xl_uni.png": "./src/assets/images/xl_uni.png",
	"./xsushi-sign-small.png": "./src/assets/images/xsushi-sign-small.png",
	"./xsushi-text-sign.png": "./src/assets/images/xsushi-text-sign.png",
	"./xsushi.png": "./src/assets/images/xsushi.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";